<div class="row">
  <div class="col-12">
    <div class="card">
      <div
        class="card-header spear-table-header-background d-flex justify-content-between"
      >
        <h6>Lien Representative</h6>
      </div>
      <div class="card-body">
        <div class="col-12 primary-tab">
          <ul class="nav nav-tabs">
            <li class="nav-item" *ngFor="let tab of pageTabs">
              <button
                class="nav-link text-uppercase"
                [ngClass]="{
                  'active search-spear-background': activeTab == tab
                }"
                (click)="activeTab = tab"
              >
                {{ tab }}
              </button>
            </li>
          </ul>
          <ng-container *ngIf="activeTab == 'Overview'">
            <div class="row">
              <div class="col-12">
                <div class="search-spear-background" *blockUI="'program-location-details'">
                  <div class="row">
                    <div class="col-12">
                      <div class="d-flex justify-content-end w-100 my-2">
                        <div>
                          <button
                            class="btn viewBtn btn-primary text-white btn-sm mr-1"
                          >
                            Edit
                          </button>
                        </div>
                      </div>
                      <div
                        class="accordian-tab card-header title-space spear-table-header-background"
                      >
                        <h6 class="m-0">General Information</h6>
                        <div>
                          <button class="btn">
                            <em
                              (click)="generalInfo = !generalInfo"
                              class="fa fa-sort-desc"
                              [ngClass]="generalInfo ? '' : 'antirotate'"
                            ></em>
                          </button>
                        </div>
                      </div>
                      <div [ngClass]="generalInfo ? 'collapsecard' : 'expandcard'">
                        <div class="card border-0 card-scrollbar bg-transparent">
                          <div
                            class="card-body p-3 text-black-contrast text-sm text-dark-bold"
                          >
                            <div class="row">
                              <div class="col-2 text-right">Email:</div>
                              <div class="col-6">
                                --
                              </div>
                            </div>

                            <div class="row my-2">
                              <div class="col-2 text-right">Work Phone:</div>
                              <div class="col-6"> -- </div>
                            </div>

                            <div class="row my-2">
                              <div class="col-2 text-right">Mobile Phone:</div>
                              <div class="col-3"> -- </div>
                            </div>
                            <div class="row my-2">
                              <div class="col-2 text-right">DOB:</div>
                              <div class="col-3"> -- </div>
                            </div>

                            <div class="row my-2">
                              <div class="col-2 text-right">Current Company:</div>
                              <div class="col-3">--</div>
                            </div>

                            <div class="row my-2">
                              <div class="col-2 text-right">Prior Companies:</div>
                              <div class="col-10">
                                <table class="table">
                                  <thead>
                                    <tr>
                                      <th class="border-0" scope="col">Company Name</th>
                                      <th class="border-0" scope="col">
                                        Title
                                      </th>
                                      <th class="border-0" scope="col">
                                        Date FRom
                                      </th>
                                      <th class="border-0" scope="col">
                                        Date To
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr class="bg-white">
                                      <td colspan="4" class="text-center">
                                        Data not available
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div
                        class="accordian-tab card-header title-space spear-table-header-background"
                      >
                        <h6 class="m-0">Notepad</h6>
                        <div>
                          <button class="btn">
                            <em
                              (click)="instructionNotesInfo = !instructionNotesInfo"
                              class="fa fa-sort-desc"
                              [ngClass]="instructionNotesInfo ? '' : 'antirotate'"
                            ></em>
                          </button>
                        </div>
                      </div>
                      <div
                        [ngClass]="
                          instructionNotesInfo ? 'collapsecard' : 'expandcard'
                        "
                      >
                        <div class="card border-0 card-scrollbar bg-transparent">
                          <div
                            class="card-body p-3 text-black-contrast text-sm text-dark-bold"
                          >
                          <table class="table">
                            <thead>
                              <tr>
                                <th class="border-0" scope="col">Date</th>
                                <th class="border-0" scope="col">
                                  Title
                                </th>
                                <th class="border-0" scope="col">
                                  Description
                                </th>
                                <th class="border-0" scope="col">
                                  File
                                </th>
                                <th class="border-0" scope="col">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr class="bg-white">
                                <td colspan="5" class="text-center">
                                  Data not available
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addProgramLocationContact let-modal>
  <div class="modal-header">
    <h6>Add Program Contact</h6>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modalService.dismissAll()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modal-form text-sm">
    <form [formGroup]="programContactLocationForm">
      <div class="row mb-2">
        <div class="col-12">
          <div>
            <span class="text-dark fw-500 required" for="client"
              >Client</span
            >
            <select name="client" id="client" class="form-control" formControlName="client_contact">
              <option value="">Select</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-12">
          <div>
            <span class="text-dark fw-500 required" for="program_location"
              >Location</span
            >
            <select name="program_location" id="program_location" class="form-control" formControlName="program_location">
              <option value="">Select</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-12">
          <div>
            <span class="text-dark fw-500 required" for="role"
              >Role</span
            >
            <select name="role" id="role" class="form-control" formControlName="role">
              <option value="">Select</option>
            </select>
          </div>
        </div>
      </div>

      <div class="mt-4 d-flex justify-content-end">
        <div>
          <button
            type="button"
            class="btn btn-secondary btn-sm text-white mr-1"
            (click)="modalService.dismissAll()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-info btn-sm text-white mr-1"
            [disabled]="programContactLocationForm.invalid"
          >
            Save
          </button>

          <button
            type="button"
            class="btn limos-button-background btn-sm text-white"
            [disabled]="programContactLocationForm.invalid"
          >
            Add More Contact
          </button>
        </div>
      </div>
    </form>
  </div>
</ng-template>
